/**
 * component/recruit/index
 */

import React from 'react';
import Grid from 'material-ui/Grid';
import Helmet from "../Helmet";
import PAGE_CONFIG from '../../config/recruit.json';
import SwipeableViews from 'react-swipeable-views';
import Tabs, { Tab } from 'material-ui/Tabs';
import { withStyles } from 'material-ui/styles';
import Jobs from './Jobs';
import { initGA } from '../GA'; 

function TabContainer({ children, area }) {
  return (
    <div className={`area-bg area-bg-${area} cf`}>
      <div className="tab-inner">
        <div className="middle-container">
          {children}
        </div>
      </div>
    </div>
  );
}


const styles = theme => ({
  tab_label: {
    fontSize:"20px"
  },
  tabLabel:{
    fontSize:"20px"
  }
});

class Recruit extends React.Component{
  state = {
    value: 0,
    jobs:[{
      area:'',
      job:[]
    }],
    item_jp_name:{}
  };
  
  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  componentDidMount(){
    initGA();
    
  }
  // componentWillMount(){
  //   this.props.getData();
  // }

  // componentWillReceiveProps(nextProps){
  //   this.setState({
  //     jobs: nextProps.recruit_data.jobs,
  //     item_jp_name: nextProps.recruit_data.item_jp_name
  //   });
  // }
  render(){
    return (
      <div className="center-container">
        <Helmet title={PAGE_CONFIG.title} description={PAGE_CONFIG.description} canonical={PAGE_CONFIG.canonical} />
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <div className="contents-title-cont">
                <h1 className="contents-title">{PAGE_CONFIG.title}</h1>
                <p className="contents-sub-title">{PAGE_CONFIG.sub_title}</p>
              </div>
              <div className="middle-container tab-container">
                <Tabs
                  value={this.state.value}
                  onChange={this.handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  fullWidth
                >
                  <Tab className={this.props.classes.tab_label} label="横浜" />
                  <Tab label="札幌" />
                  <Tab label="福岡" />
                </Tabs>
              </div>
              <SwipeableViews className="swip-container"
                index={this.state.value}
                onChangeIndex={this.handleChangeIndex}
              >
              {
                PAGE_CONFIG.jobs.map((key) => {
                  return(
                    <TabContainer area={key.area} key={key.area}>
                      <Jobs item={key.job} item_name={PAGE_CONFIG.item_jp_name} />
                    </TabContainer>
                  )
                })
                // this.state.jobs.map((key) => {
                //   return(
                //     <TabContainer area={key.area} key={key.area}>
                    
                //       <Jobs item={key.job} item_name={this.state.item_jp_name} />
                //     </TabContainer>
                //   )
                // })
              }
              </SwipeableViews>
            </Grid>
          </Grid>
        </div>
    )
  }
}

export default withStyles(styles, { withTheme: true })(Recruit);



// WEBPACK FOOTER //
// ./src/component/recruit/index.js